/* istanbul ignore file */
import { useState } from 'react';
import Box from '@mui/material/Box';
import {
  isCurrentOpportunityStage,
  isFailedOpportunityStage,
  POSTPONED,
} from 'domain/sales/opportunity/opportunityService';
import { useShowContext } from 'framework/show';
import { sortBy } from 'lodash';
import OpportunityPipelineDescription from 'domain/sales/opportunity/shared/OpportunityPipeline/OpportunityPipelineDescription';
import OpportunityPipelineStepper from 'domain/sales/opportunity/shared/OpportunityPipeline/OpportunityPipelineStepper';
import { opportunityPipelineSx } from './opportunityPipelineStyles';

const OpportunityPipeline = () => {
  const { data } = useShowContext();
  const crmPipeline = data.getValueBySource('crmPipeline');
  const steps = sortBy(crmPipeline?.steps || [], 'orderPosition');
  const currentStep =
    steps.find(({ stateStatus }) => isCurrentOpportunityStage(stateStatus))?.stepName || steps[0]?.stepName;

  const isPipelineFailed = steps.some(({ stateStatus }: any) => isFailedOpportunityStage(stateStatus));

  const [activeStep, setActiveStep] = useState(currentStep);
  const activeStepData = steps.find(step => step.stepName === activeStep);
  const isPostponedNow = data.getValueBySource('stateStep') === POSTPONED;

  const handleStep = (step: string) => {
    setActiveStep(step);
  };

  return (
    <Box sx={opportunityPipelineSx}>
      <OpportunityPipelineStepper
        activeStep={activeStep}
        handleStep={handleStep}
        steps={steps}
        isPostponed={isPostponedNow}
      />

      <OpportunityPipelineDescription
        currentStep={currentStep}
        activeStepData={activeStepData}
        handleStep={handleStep}
        isPipelineFailed={isPipelineFailed}
        isPostponed={isPostponedNow}
      />
    </Box>
  );
};

export default OpportunityPipeline;
